import React from "react";
import { Tooltippy } from "../actions/Tippy";

import { ReactComponent as HappyRating } from "../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../build/images/icons-rating/indifferent.svg";
import { ReactComponent as SadRating } from "../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../build/images/icons-rating/star-slash.svg";

export const renderAvaliation = (atd) => {
  switch (atd.score_class) {
    case "otimo":
      return (
        <Tooltippy content={atd.score_value} placement="top">
          <div className="username-rating__tag happy">
            <HappyRating />
            Cliente satisfeito
          </div>
        </Tooltippy>
      );

    case "promotor":
      return (
        <Tooltippy content={atd.score_value} placement="top">
          <div className="username-rating__tag happy">
            <HappyRating />
            Cliente satisfeito
          </div>
        </Tooltippy>
      );

    case "razoavel":
      return (
        <Tooltippy content={atd.score_value} placement="top">
          <div className="username-rating__tag indifferent">
            <IndifRating />
            Cliente indiferente
          </div>
        </Tooltippy>
      );

    case "neutro":
      return (
        <Tooltippy content={atd.score_value} placement="top">
          <div className="username-rating__tag indifferent">
            <IndifRating />
            Cliente indiferente
          </div>
        </Tooltippy>
      );

    case "ruim":
      return (
        <Tooltippy content={atd.score_value} placement="top">
          <div className="username-rating__tag sad">
            <SadRating />
            Cliente insatisfeito
          </div>
        </Tooltippy>
      );

    case "detrator":
      return (
        <Tooltippy content={atd.score_value} placement="top">
          <div className="username-rating__tag sad">
            <SadRating />
            Cliente insatisfeito
          </div>
        </Tooltippy>
      );

    default:
      return (
        <div className="username-rating__tag">
          <NullRating />
          Nenhuma avaliação
        </div>
      );
  }
};
